
export interface PartnerType {
  id: number;
  name: string;
  isActive: boolean;
}
